// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { SET_PRODUCT_DATA } from './types'

import { setNestedInReduxState } from 'redux/helpers'

const initialState = {}

const dataProducts = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCT_DATA :
      return setNestedInReduxState(
        state,
        `${action.productUId}`,
        action.data,
      )

    default :
      return state
  }
}

export default dataProducts
